import React from 'react'
import { useState } from 'react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useOpenProfileMutation } from '../../../services/chatApi';
import ProfileOpenModal from './Right/ProfileOpenModal';
import { mediaModalActions } from '../../../services/mediaModalSlice';
import emptyavatar from '../../../assets/images/emptyavatar.webp'
import { BASE_URL } from '../../../keys';
import { Link } from 'react-router-dom';
import api from '../../../services/api';

const ClientInfo = () => {
    // const [chatlistuser,setChatListUser]=useState()
    const coachName = useSelector((state) => state.coachReducer.coachName);
    const coachId = useSelector((state) => state.coachReducer.coach_id);
    const [currentUser, setCurrentUser] = useState({});
    const currentModal = useSelector((state) => state.mediaModalReducer.currentModal);
    // useEffect(() => {
    //     const listUsers = setInterval(() => {
    //         api.get(`common/list-of-users-in-chat/`, {
    //             headers: {
    //                 authorization: `Bearer ${localStorage.getItem('livtoken')}`,
    //             },
    //         }).then((res) => {
    //             setChatListUser(res?.data.data)
    //         })
    //     }) 
       
    // }, []);
     const chatlistuser = useSelector((state) => state.plan.reservation)


      const activeCoachId = useSelector((state) => state.coachReducer.coach_id)
    
      
       const activeChatItem = chatlistuser?.data?.find(item => item.coach_id === activeCoachId)
    localStorage.setItem("categoryid",activeChatItem?.category_id)
      
       
    const dispatch = useDispatch();

const today = new Date();
today.setHours(0, 0, 0, 0);

const planReservation = activeChatItem?.plan_reservation;


const coachCategory = activeChatItem?.coach_category;

let showViewPlansButton = false;
const bookingcount=localStorage.getItem("bookingdone")


if (coachCategory === 'NUTRITION & FITNESS' && bookingcount>0) {
  if (planReservation) {
    const endDateStr = planReservation.end_to;
  
      const endDate = new Date(endDateStr);
      endDate.setHours(0, 0, 0, 0); // Normalize time
    
      
      if (endDate <= today) {
        showViewPlansButton = true;
      }
      else {
  
    showViewPlansButton = false;
  }
    }
    else{
        showViewPlansButton=true
    }
  } 


    const [modal, setModal] = useState(false);
    const [openProfile, { isLoading, isError }] = useOpenProfileMutation();

    const profileOpenHandler = async () => {
        const formData = new FormData();
        formData.append('person_id', coachId);

        const response = await openProfile(formData);
        
        
        if (response.data) {
            setCurrentUser(response.data.data)
        }
    }
    useEffect(() => {
        profileOpenHandler();
    }, [coachId]);

    return (
        <aside className="bg-[#FDE9D8] border-[1.5px] border-[#FFDBB0] rounded-2xl w-[250px] mt-4 p-0 text-center flex flex-col justify-center basis-2/4">
            <>
                <div className="w-full font-bold text-[1.3rem] font-constantia leading-8">
                    Coach Information
                </div>
                <div className="flex justify-center p-1 border-[#FFDBB0] ">
                    <img
                   
                        src={currentUser.profile_pic != 0 ?
                            `${BASE_URL}${currentUser.profile_pic}` :
                            emptyavatar} 
                            onError={(e) => {
    e.currentTarget.src = emptyavatar;
  }}
                        alt="profile image"
                        className="w-[55px] h-[55px] rounded-full object-cover border-[#FFDBB0] "
                    />
                </div>
                <p className="w-full font-bold text-[1rem] font-ubuntu leading-8 pb-4">{coachName}</p>
                <button
                    onClick={() => {
                        setModal(true);
                        dispatch(mediaModalActions.toggleModal("profileOpen"))
                    }}
                    className="mx-auto bg-[#FFDBB0] mb-2 px-4 font-ubuntu items-center text-center h-[40px] rounded-[20px] w-[155px] font-bold text-lightOrange">
                    See More
                </button>
                {modal && <ProfileOpenModal currentUser={currentUser} closeModal={() => setModal(false)} />}
                   {showViewPlansButton &&<Link to="/choose-plan">  
                   <button
    
                    className="mx-auto my-3 bg-[#F76411] px-4 font-ubuntu items-center text-center h-[40px] rounded-[20px] w-[155px] font-bold text-white">
                    View Plans
                </button>
                </Link>}
            </>
        </aside>
    )
}

export default ClientInfo